module.exports = __webpack_public_path__ + "static/media/home-icon-selected.21b2e4ab.svg";